import React, {useEffect, useRef, useState} from 'react';
import {makeApiCall} from '../../../Api/makeApiCall';
import * as _ from "lodash";
import PropTypes from "prop-types";
import {makeApolloClientCall} from "../../../Api/makeApolloApiCall";
import SelectDropdown from "./SelectDropdown";
import {toastError} from "../../../utils/toast";
import {toast} from "react-toastify";

const getPeriodsList = () => {
    return makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/timeService`)
        .then(result => result.data);
};

const getMarketPeriodsList = (graphqlQuery, periodsFunction, toastErrorMessage) => {
    return makeApolloClientCall(graphqlQuery)
        .then(periodsFunction)
        .catch(() => {
            if(toastErrorMessage) {
                toastError(toast, toastErrorMessage);
            }
        });
};

const PeriodsDropdown = ({
                             periodOptionsMapFunction = period => period.periodAbbreviation,
                             periodOptionsFilterFunction = undefined,
                             updatePeriod,
                             periodLabel = 'Period',
                             graphqlQuery,
                             periodsFunction = result => result.marketPeriodList.map(period => ({periodAbbreviation: period})),
                             className,
                             selectedPeriod,
                             showLabel = true,
                             isDisabled = false,
                             id = 'period',
                             toastErrorMessage = undefined
                         }) => {

    const [periodOptions, setPeriodOptions] = useState([]);
    const [periodList, setPeriodList] = useState([]);

    const periodsFunctionRef = useRef(periodsFunction);
    periodsFunctionRef.current = periodsFunction;
    const periodOptionsMapFunctionRef = useRef(periodOptionsMapFunction);
    periodOptionsMapFunctionRef.current = periodOptionsMapFunction;
    const periodOptionsFilterFunctionRef = useRef(periodOptionsFilterFunction);
    periodOptionsFilterFunctionRef.current = periodOptionsFilterFunction;
    const toastErrorMessageRef = useRef(toastErrorMessage);
    toastErrorMessageRef.current = toastErrorMessage;

    useEffect(() => {
        const periods = graphqlQuery ? getMarketPeriodsList(graphqlQuery, periodsFunctionRef.current, toastErrorMessageRef.current) : getPeriodsList()
        periods
            .then((periodList) => {
                let periodOptionsMapped = _.uniq(periodList?.map(periodOptionsMapFunctionRef.current).sort().reverse());
                periodOptionsMapped = periodOptionsFilterFunctionRef.current?.(periodOptionsMapped, periodList) || periodOptionsMapped
                periodOptionsMapped = periodOptionsMapped.map(option => ({value: option, label: option}));
                setPeriodOptions(periodOptionsMapped);
                setPeriodList(periodList)
            });
    }, [graphqlQuery]);

    return (
        <SelectDropdown
            id={`${id}_dropdown`}
            dataTestId={`${id}_dropdown`}
            inputLabel={showLabel ? periodLabel: undefined}
            onChange={
                (option) => {
                    const period = periodList.find(period => periodOptionsMapFunction(period) === option.value);
                    updatePeriod(option.value, period);
                }
            }
            options={periodOptions}
            selectValue={selectedPeriod}
            isDisabled={isDisabled}
        />
    );
}


PeriodsDropdown.propTypes = {
    periodOptionsMapFunction: PropTypes.func,
    periodOptionsFilterFunction: PropTypes.func,
    updatePeriod: PropTypes.func.isRequired,
    periodLabel: PropTypes.string,
    graphqlQuery: PropTypes.string,
    periodsFunction: PropTypes.func,
    className: PropTypes.string,
    selectedPeriod: PropTypes.string,
    showLabel: PropTypes.bool,
    isDisabled: PropTypes.bool,
    id: PropTypes.string,
    toastErrorMessage: PropTypes.string
};

export default PeriodsDropdown;
